import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getTemplatesSuccess,
    getTemplatesFailure,
    getTemplateSuccess,
    getTemplateFailure,
    createTemplateSuccess,
    createTemplateFailure,
    updateTemplateSuccess,
    updateTemplateFailure,
    deleteTemplateSuccess,
    deleteTemplateFailure,
    seedTemplatesSuccess,
    seedTemplatesFailure,
} from './slice';
import requestHandler from '../../../utils/requestHandler';
import { logoutRequest } from '../auth/authSlice';

const API_BASE = `${process.env.REACT_APP_SERVER_API}api/report-templates`;

function* getTemplatesSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const currentBranch = yield select(state => state.branch.currentBranch);
        const { category } = action.payload || {};

        const queryParams = new URLSearchParams();
        if (category) queryParams.append('category', category);

        const response = yield call(requestHandler, `${API_BASE}?${queryParams}`, {
            method: 'GET',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
                'X-Current-Branch': currentBranch?.id
            }
        });

        yield put(getTemplatesSuccess(response));
    } catch (error) {
        yield put(getTemplatesFailure(error?.response?.message || error.message));
    }
}

function* getTemplateSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id } = action.payload;

        const response = yield call(requestHandler, `${API_BASE}/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
                'X-Current-Branch': currentBranch?.id
            }
        });

        yield put(getTemplateSuccess(response));
    } catch (error) {
        yield put(getTemplateFailure(error?.response?.message || error.message));
    }
}

function* createTemplateSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const currentBranch = yield select(state => state.branch.currentBranch);

        const response = yield call(requestHandler, API_BASE, {
            method: 'POST',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
                'X-Current-Branch': currentBranch?.id
            },
            body: JSON.stringify(action.payload)
        });

        yield put(createTemplateSuccess(response));
    } catch (error) {
        yield put(createTemplateFailure(error?.response?.message || error.message));
    }
}

function* updateTemplateSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id, ...data } = action.payload;

        const response = yield call(requestHandler, `${API_BASE}/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
                'X-Current-Branch': currentBranch?.id
            },
            body: JSON.stringify(data)
        });

        yield put(updateTemplateSuccess(response));
    } catch (error) {
        yield put(updateTemplateFailure(error?.response?.message || error.message));
    }
}

function* deleteTemplateSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const currentBranch = yield select(state => state.branch.currentBranch);
        const { id } = action.payload;

        const response = yield call(requestHandler, `${API_BASE}/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
                'X-Current-Branch': currentBranch?.id
            }
        });

        yield put(deleteTemplateSuccess(response));
    } catch (error) {
        yield put(deleteTemplateFailure(error?.response?.message || error.message));
    }
}

function* seedTemplatesSaga() {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const currentBranch = yield select(state => state.branch.currentBranch);

        const response = yield call(requestHandler, `${API_BASE}/seed`, {
            method: 'POST',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
                'X-Current-Branch': currentBranch?.id
            }
        });

        yield put(seedTemplatesSuccess(response));
    } catch (error) {
        yield put(seedTemplatesFailure(error?.response?.message || error.message));
    }
}

function* saga() {
    yield takeLatest('reportTemplate/getTemplatesRequest', getTemplatesSaga);
    yield takeLatest('reportTemplate/getTemplateRequest', getTemplateSaga);
    yield takeLatest('reportTemplate/createTemplateRequest', createTemplateSaga);
    yield takeLatest('reportTemplate/updateTemplateRequest', updateTemplateSaga);
    yield takeLatest('reportTemplate/deleteTemplateRequest', deleteTemplateSaga);
    yield takeLatest('reportTemplate/seedTemplatesRequest', seedTemplatesSaga);
}

export default saga;
